import { Component } from "@angular/core";

@Component({
    selector: "account-home",
    templateUrl: "./accounthome.component.html",
    standalone: false
})
export class AccountHomeComponent {
}
